import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  menuOpen: false,
  theme: 'dark',
  loading: false,
  activeSection: 'hero',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.menuOpen = !state.menuOpen;
    },
    closeMenu: (state) => {
      state.menuOpen = false;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
  },
});

export const { toggleMenu, closeMenu, setTheme, setLoading, setActiveSection } = uiSlice.actions;
export default uiSlice.reducer;
